/* Feature-flags service entrypoint. Picks the Amplitude-backed impl when a
 * deployment key is configured, else a noop (all flags off) — mirroring the
 * SaaS-vs-noop split in ../stigg. Consumers import from here, never the impls. */

import { FLAGS_ENABLED } from "./flags.config";
import { NoopFlagsService } from "./noop-flags.service";
import { SaasFlagsService } from "./saas-flags.service";
import type { IFlagsService } from "./flags.types";

const flagsService: IFlagsService = FLAGS_ENABLED
  ? new SaasFlagsService()
  : new NoopFlagsService();

export const FlagsProvider = flagsService.FlagsProvider;
export const useFlags = flagsService.useFlags;
export const useEmailPasswordAuth = flagsService.useEmailPasswordAuth;

export {
  FLAGS_ENABLED,
  STIGG_ENABLED_FLAG,
  EMAIL_PASSWORD_AUTH_FLAG,
  PERSONALIZATION_LEVEL_FLAG,
  HARNESS_OPTIMIZER_APP_FLAG,
} from "./flags.config";
export type { FlagsState, EmailPasswordAuthState } from "./flags.types";
